var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-modal',{attrs:{"modal-content-class":"reg_after_login"}},[_c('div',{staticClass:"modal-card"},[_c('div',{staticClass:"content"},[_c('img',{attrs:{"src":"/static/images/register/mobile_img.svg","alt":"info"}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.getTranslations.home_modals_simplify_registration_text))])])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218161c7","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/modals/RegisterViaSms.vue
// module id = null
// module chunks = 